import { render } from "./PhiDichVu.vue?vue&type=template&id=06cad742"
import script from "./PhiDichVu.vue?vue&type=script&lang=js"
export * from "./PhiDichVu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__